<template>
    <b-tabs pills active-nav-item-class="nav-pill-secondary" nav-class="bg-light p-25 custom-nav">
        <b-tab title="Genel" active>
            <div class="row">
                <div class="col-12 col-lg-6 mb-1">
                    <label class="form-label">Şube Adı</label>
                    <input type="text" class="form-control" v-model="value.Name" placeholder="Şube Adı" />
                </div>
                <div class="col-12 col-lg-6 mb-1">
                    <label class="form-label">Şube Tipi</label>
                    <v-select-list v-model="type" label="Name" placeholder="Şube Tipi" :options="types"/>
                </div>
                <div class="col-12 col-lg-6 mb-1">
                    <label class="form-label">Sicil Numarası</label>
                    <input type="text" class="form-control" v-model="value.RegistryNumber" placeholder="Sicil Numarası" />
                </div>
                <div class="col-12 col-lg-6 mb-1">
                    <label class="form-label">Vergi Numarası</label>
                    <input type="text" class="form-control" v-model="value.TaxNumber" placeholder="Vergi Numarası" />
                </div>
                <div class="col-12 col-lg-6 mb-1">
                    <label class="form-label">İl</label>
                    <v-select-list v-model="province" placeholder="İl" label="Name" :options="provinces"/>   
                </div>
                <div class="col-12 col-lg-6 mb-1">
                    <label class="form-label">İlçe</label>
                    <v-select-list :disabled="!province" placeholder="İlçe" v-model="district" label="Name" :options="districts"/>
                </div>
                <div class="col-md-6 mb-1" v-if="$safe(type,'Code') == 'O'">
                    <label class="form-label">Puantaj Sorumlusu</label>
                    <v-select-list v-model="employee" :options="employees" label="Combine" v-on:search="searchEmployees" placeholder="Puantaj Sorumlusu" :loading="employeeLoading"></v-select-list>
                </div>
                <div class="col-md-6 mb-1" v-if="$safe(type,'Code') == 'O'">
                    <label class="form-label">Şube Sorumlusu</label>
                    <v-select-list v-model="managerEmployee" :options="managerEmployees" label="Combine" v-on:search="searchManagerEmployees" placeholder="Şube Sorumlusu" :loading="managerEmployeeLoading"></v-select-list>
                </div>
                <div class="col-12 col-lg-6 mb-1">
                    <label class="form-label">Netsis Şube Adı</label>
                    <v-select-list placeholder="Netsis Şube Adı" v-model="sube" label="Name" :options="subes"/>
                </div>
                <div class="col-12 col-lg-6 mb-1" v-if="$safe(type,'Code') == 'S'">
                    <label class="form-label">Hafta Tatili</label>
                    <select v-model="value.OffDay" class="form-control">
                        <option v-for="day in dayOfWeek" :value="day.value" :key="day.value">{{day.name}}</option>
                    </select>
                </div>
                <div class="col-12 mb-1">
                    <label class="form-label">Şube Adresi</label>
                    <textarea class="form-control resize-none" v-model="value.Address" placeholder="Şube Adresi"></textarea>
                </div>
                <div class="col-12 mb-1" v-if="$safe(type,'Code') == 'S'">
                    <label class="form-label">UAVT Kodu</label>
                    <input type="text" class="form-control" v-model="value.UAVTCode" placeholder="UAVT Kodu" />
                </div>
                <div class="col-12 col-lg-6 mb-1" v-if="$safe(type,'Code') == 'S'">
                    <label class="form-label">SGK Şube Kullanıcı Adı</label>
                    <input type="text" autocomplete="new-password" class="form-control" v-model="value.SGKBranchUsername" placeholder="SGK Şube Kullanıcı Adı" />
                </div>
                <div class="col-12 col-lg-6 mb-1" v-if="$safe(type,'Code') == 'S'">
                    <label class="form-label">SGK Şube Şifresi</label>
                    <b-input-group class="input-group-merge">
                    <b-form-input v-model="value.SGKBranchPassword" autocomplete="new-password" class="form-control-merge" :type="branchPasswordFieldType" placeholder="············"/>
                        <b-input-group-append is-text>
                            <feather-icon class="cursor-pointer" :icon="branchPasswordToggleIcon" @click="toggleBranchPasswordVisibility"/>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div class="col-12 col-lg-6 mb-1" v-if="$safe(type,'Code') == 'S'">
                    <label class="form-label">SGK Sistem Şifresi</label>
                    <b-input-group class="input-group-merge">
                    <b-form-input v-model="value.SGKSystemPassword" class="form-control-merge" :type="systemPasswordFieldType" placeholder="············"/>
                        <b-input-group-append is-text>
                            <feather-icon class="cursor-pointer" :icon="systemPasswordToggleIcon" @click="toggleSystemPasswordVisibility"/>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div class="col-12 col-lg-6 mb-1" v-if="$safe(type,'Code') == 'S'">
                    <label class="form-label">SGK Şube Kodu</label>
                    <input type="text" class="form-control" v-model="value.SGKBranchCode" placeholder="SGK Şube Kodu" />
                </div>
                <div class="col-12 col-lg-6 mb-1" v-if="$safe(type,'Code') == 'S'">
                    <label class="form-label">Tehlike Sınıfı</label>
                    <v-select-list placeholder="Tehlike Sınıfı" v-model="hClass" label="Value" :options="hClasses"/>
                </div>
                <div class="col-12 mb-1">
                    <b-form-checkbox v-model="value.IsActive" id="active-branch">Aktif</b-form-checkbox>
                </div>
                <div class="col-12">
                    <b-form-checkbox v-model="value.IsAbroad" id="active-abroad">Yurtdışı Şubesi</b-form-checkbox>
                </div>
            </div>
        </b-tab>
        <!-- <b-tab title="NETSIS" v-if="$safe(type,'Code') == 'S'">
            <branch-netsis-info v-model="value"></branch-netsis-info>
        </b-tab> -->
    </b-tabs>
</template>

<script>
import {BFormCheckbox,BInputGroup,BFormInput,BInputGroupAppend,BTabs,BTab} from 'bootstrap-vue'
import CompanyApi from '@/api/company';
import HrNetsisApi from '@/api/hr-netsis';
import SystemDataApi from '@/api/system-data'
import EmployeeOperations from '@/api/employee-operations'
import BranchNetsisInfo from './BranchNetsisInfo.vue'
import HazardClassApi from '@/api/hazard-class';

export default {
    components: {
        BFormCheckbox,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BTabs,
        BTab,
        BranchNetsisInfo
    },
    props:{
        value:Object
    },
    data(){
        return {
            branchPasswordFieldType: 'password',
            systemPasswordFieldType: 'password',
            types:[],
            provinces:[],
            districts:[],
            employeeLoading:false,
            managerEmployeeLoading:false,
            employees:[],
            managerEmployees:[],
            hClasses:[],
            subes:[],
            dayOfWeek:[
                {value:0,name:"Pazar"},
                {value:1,name:"Pazartresi"},
                {value:2,name:"Salı"},
                {value:3,name:"Çarşamba"},
                {value:4,name:"Perşembe"},
                {value:5,name:"Cuma"},
                {value:6,name:"Cumartesi"},
            ]
        }
    },
    watch:{
        "value.AddressProvinceId"(nevV,oldV){
            if(nevV != oldV){
                this.getDistricts()
                this.value.AddressDistrictId = null
            }
        }
    },
    mounted(){
        this.getTypes()
        this.getProvinces()
        this.getDistricts()
        this.getSubes()
        this.getHClasses()
        if(this.value.EmployeeFullName){
            this.searchEmployees(this.value.EmployeeFullName)
        }
    },
    methods: {
        getSubes(){
            HrNetsisApi.SubeList().then(res=>{
                this.subes = res.data.Data
            })
        },
        getHClasses(){
            HazardClassApi.NameList().then(res =>{
                this.hClasses = res.data.Data || []
            })
        },
        toggleBranchPasswordVisibility() {
            this.branchPasswordFieldType = this.branchPasswordFieldType === 'password' ? 'text' : 'password'
        },
        toggleSystemPasswordVisibility() {
            this.systemPasswordFieldType = this.systemPasswordFieldType === 'password' ? 'text' : 'password'
        },
        searchEmployees(search){
            if(search){
                this.employeeLoading = true
                EmployeeOperations.Employee.Search(search)
                .then(res=>{
                    this.employees = res.data.Data?.map(d=>({
                        ...d,
                        Combine:[d.IdentityNumber,d.FullName].join(' - ')
                    }))
                    this.employeeLoading = false
                }).catch(err=>{ 
                    this.employeeLoading = false 
                })
            }
        },
        searchManagerEmployees(search){
            if(search){
                this.managerEmployeeLoading = true
                EmployeeOperations.Employee.Search(search)
                .then(res=>{
                    this.managerEmployees = res.data.Data?.map(d=>({
                        ...d,
                        Combine:[d.IdentityNumber,d.FullName].join(' - ')
                    }))
                    this.managerEmployeeLoading = false
                }).catch(err=>{ 
                    this.managerEmployeeLoading = false 
                })
            }
        },
        getTypes(){
            CompanyApi.Branch.Type().then(res=>{
                this.types = res.data.Data
            })
        },
        getProvinces(){
            SystemDataApi.Province().then(response=>{
                this.provinces = response.data.Data
            })
        },
        getDistricts(){
            if(this.value.AddressProvinceId){
                SystemDataApi.District(this.value.AddressProvinceId)
                .then(res=>{
                    this.districts = res.data.Data
                })
            }
        }
    },
    computed:{
        branchPasswordToggleIcon() {
            return this.branchPasswordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
        systemPasswordToggleIcon() {
            return this.branchPasswordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
        sube:{
            get:function(){

                return this.subes.find(b=>b.Name==this.value?.NetsisIsYeri)
            },
            set:function(value){
                this.value.NetsisIsYeri = value.Name || null
            }
        },
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.BranchTypeId)
            },
            set:function(value){
                this.value.BranchTypeId = value?.Id || null
            }
        },
        province:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.AddressProvinceId)
            },
            set:function(value){
                this.value.AddressProvinceId = value?.Id || null
            }
        },
        district:{
            get:function(){
                return this.districts.find(s=>s.Id==this.value.AddressDistrictId)
            },
            set:function(value){
                this.value.AddressDistrictId = value?.Id || null
            }
        },
        employee:{
            get:function(){
                return this.employees.find(s=>s.Id==this.value.EmployeeId)
            },
            set:function(value){
                this.value.EmployeeId = value?.Id || null
            }
        },
        managerEmployee:{
            get:function(){
                return this.managerEmployees.find(s=>s.Id==this.value.ManagerEmployeeId)
            },
            set:function(value){
                this.value.ManagerEmployeeId = value?.Id || null
            }
        },
        hClass:{
            get:function(){
                return this.hClasses.find(s=>s.Key==this.value.HazardClassId)
            },
            set:function(value){
                this.value.HazardClassId = Number(value?.Key) >= 0 ? value.Key :  null
            }
        }
    }
}
</script>

<style>
.custom-nav .nav-link{
    margin: 0.25rem;
}
.custom-nav .nav-link:not(.active){
    border: 1px solid hsl(222, 17%, 85%);
    background-color: #ffffff;
}

.dark-layout .custom-nav .nav-link:not(.active){
    border: 1px solid hsl(222, 17%, 40%);
    background-color: #283046;
}
</style>